import {Component, inject} from '@angular/core';
import {Location} from '@angular/common';
import {Button} from 'primeng/button';

@Component({
    selector: 'app-back-button',
    imports: [
        Button
    ],
    template: `<p-button styleClass="p-2" size="large" text="true" icon="pi pi-arrow-left" severity="secondary" (onClick)="go()" />`
})
export class BackButtonComponent {
  private location = inject(Location);


  go(): void {
    this.location.back();
  }
}
